import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { ApiParams, prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { getApiKeysApi } from '@/api/v1/api-key/getApiKeysApi';
import { CreateApiKeyPayloadType, createApiKeyApi } from '@/api/v1/api-key/createApiKeyApi';
import { updateApiKeyApi, UpdateApiKeyPayloadType } from '@/api/v1/api-key/updateApiKeyApi';
import { deleteApiKeyApi } from '@/api/v1/api-key/deleteApiKeyApi';

export const getApiKeys = async (params: ApiParams) => {
  const apiParams = prepareBaseListApiParams(params);

  try {
    const response = await getApiKeysApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const createApiKey = async (payload: CreateApiKeyPayloadType) => {
  try {
    const response = await createApiKeyApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const updateApiKey = async (apiKeyId: string, payload: UpdateApiKeyPayloadType) => {
  try {
    const response = await updateApiKeyApi(apiKeyId, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const deleteApiKey = async (apiKeyId: string) => {
  try {
    const response = await deleteApiKeyApi(apiKeyId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
